import { z } from "zod";

export const receitaIngredienteSchema = z.object({
  id_receita_ingrediente: z.string().optional(),
  produto_id: z.string().uuid("Selecione um produto válido"),
  produto_nome: z.string().min(1, "Nome do produto é obrigatório"),
  
  // Medições (validação customizada para exclusividade)
  peso_gramas: z.number().positive("Peso deve ser maior que zero").optional(),
  volume_ml: z.number().positive("Volume deve ser maior que zero").optional(),
  quantidade_unidades: z.number().positive("Quantidade deve ser maior que zero").optional(),
  
  // Controle e qualidade
  desperdicio_percentual: z.number().min(0).max(100, "Desperdício deve estar entre 0 e 100%").optional(),
  ordem_preparo: z.string().optional(),
  tipo_ingrediente: z.string().optional(),
  observacoes: z.string().optional(),
  alergenos: z.string().optional(),
  substituivel: z.string().optional(),
  opcional_receita: z.string().optional(),
}).refine(
  (data) => {
    // Validação: apenas 1 campo de medição preenchido
    const preenchidos = [data.peso_gramas, data.volume_ml, data.quantidade_unidades].filter(v => v !== undefined && v !== null);
    return preenchidos.length === 1;
  },
  {
    message: "Preencha apenas UM campo entre Peso, Volume ou Quantidade",
    path: ["peso_gramas"],
  }
);

export const receitaSchema = z.object({
  nome: z.string().min(3, "Nome deve ter pelo menos 3 caracteres"),
  categoria: z.string().optional(),
  subcategoria: z.string().optional(),
  porcao: z.string().optional(),
  dificuldade: z.string().optional(),
  rendimento: z.number().positive("Rendimento deve ser maior que zero").optional(),
  tamanho: z.enum(['mini_30g', 'pequeno_120g', 'medio_500g', 'grande_1kg']).optional(),
  tempo_preparo_minutos: z.string().optional(),
  tempo_forno_minutos: z.string().optional(),
  temperatura_forno_celsius: z.string().optional(),
  tempo_descanso_minutos: z.string().optional(),
  tempo_total_minutos: z.string().optional(),
  modo_preparo: z.string().optional(),
  origem_receita: z.string().optional(),
  observacoes_receita: z.string().optional(),
  observacoes_internas: z.string().optional(),
  custo_energia: z.number().nonnegative().default(0),
  custo_ingredientes: z.number().nonnegative().default(0).optional(),
  custo_total: z.number().nonnegative().default(0).optional(),
  modo_armazenamento: z.string().optional(),
  validade_dias: z.string().optional(),
  observacoes_entrega: z.string().optional(),
  versao: z.string().optional(),
  ingredientes: z.array(receitaIngredienteSchema).min(1, "Adicione pelo menos um ingrediente"),
});

export type ReceitaFormData = z.infer<typeof receitaSchema>;
export type ReceitaIngredienteFormData = z.infer<typeof receitaIngredienteSchema>;
